export const MODAL_EDITOR_CONTAINER_ID = 'modalFunctionEditorContainer';
export const MODAL_EDITOR_ID = 'modalFunctionEditor';
export const MODAL_EDITOR_CLOSE_ID = 'closeModalFunctionEditor';
export const MODAL_EDITOR_DELETE_ID = 'modalFunctionEditorDeleteButton';
export const MODAL_EDITOR_NAME_INPUT_ID = 'modalFunctionEditorName';
export const MODAL_EDITOR_PARAM_EDITOR_INPUT_ID =
  'modalFunctionEditorParamEditor';
export const MODAL_EDITOR_DESCRIPTION_INPUT_ID =
  'modalFunctionEditorDescription';
